import React from 'react'

import 'swiper/scss'

const CardCondensed = ({ slide, slideNumber }) => {
  const { heading, background_image, description } = slide
  return (
    <swiper-slide>
      <div className='card-wrapper' style={{ backgroundImage: `url(${background_image.url}` }}>
        <div className='slide-number'>0{ slideNumber }</div>
        <h4 className='card-heading'>{heading}</h4>
        <div className='card-content'>
          <p className='card-description'>{description}</p>
        </div>
      </div>
    </swiper-slide>
  )
}

export default CardCondensed
